/*
 * @Author: Kuiper
 * @Date: 2021-06-19 13:58:08
 */
import { MockMethod } from 'vite-plugin-mock'
import { resultError, resultSuccess, getRequestToken, requestParams } from '../_util'

export function createFakeUserList() {
  return [
    {
      userId: '1',
      username: 'vben',
      realName: 'fanyanbo',
      avatar: 'https://q1.qlogo.cn/g?b=qq&nk=190848757&s=640',
      desc: 'manager',
      password: '123456',
      token: 'fakeToken1',
      roles: [
        {
          roleName: 'Super Admin',
          value: 'super',
        },
      ],
    },
    {
      userId: '2',
      username: 'test',
      password: '123456',
      realName: 'test user',
      avatar: 'https://q1.qlogo.cn/g?b=qq&nk=339449197&s=640',
      desc: 'tester',
      token: 'fakeToken2',
      roles: [
        {
          roleName: 'Tester',
          value: 'test',
        },
      ],
    },
  ]
}
//mock设备列表信息
export function devicetList() {
  return [
    {
      id: 1,
      screen_name: '应用名称1',
      mac_addr: '12345678',
      screen_model: 'H1233',
      active_time: '2020-01-04 09:41:00',
    },
    {
      id: 2,
      screen_name: '应用名称1',
      mac_addr: '12345678',
      screen_model: 'H1233',
      active_time: '2020-01-04 09:41:00',
    },
    {
      id: 2,
      screen_name: '应用名称1',
      mac_addr: '12345678',
      screen_model: 'H1233',
      active_time: '2020-01-04 09:41:00',
    },
    {
      id: 2,
      screen_name: '应用名称1',
      mac_addr: '12345678',
      screen_model: 'H1233',
      active_time: '2020-01-04 09:41:00',
    },
    {
      id: 2,
      screen_name: '应用名称1',
      mac_addr: '12345678',
      screen_model: 'H1233',
      active_time: '2020-01-04 09:41:00',
    },
    {
      id: 2,
      screen_name: '应用名称1',
      mac_addr: '12345678',
      screen_model: 'H1233',
      active_time: '2020-01-04 09:41:00',
    },
    {
      id: 2,
      screen_name: '应用名称1',
      mac_addr: '12345678',
      screen_model: 'H1233',
      active_time: '2020-01-04 09:41:00',
    },
    {
      id: 2,
      screen_name: '应用名称1',
      mac_addr: '12345678',
      screen_model: 'H1233',
      active_time: '2020-01-04 09:41:00',
    },
    {
      id: 2,
      screen_name: '应用名称1',
      mac_addr: '12345678',
      screen_model: 'H1233',
      active_time: '2020-01-04 09:41:00',
    },
    {
      id: 2,
      screen_name: '应用名称1',
      mac_addr: '12345678',
      screen_model: 'H1233',
      active_time: '2020-01-04 09:41:00',
    },
    {
      id: 2,
      screen_name: '应用名称1',
      mac_addr: '12345678',
      screen_model: 'H1233',
      active_time: '2020-01-04 09:41:00',
    },
  ]
}
export function companyInfo() {
  return [
    {
      business_id: '1234',
      tel: '18729266957',
      role: '1',
      business_name: '你真好看',
      member_num: '20',
      device_num: '111',
    },
  ]
}
export function memberList() {
  return [
    {
      id: 1,
      name: '靓女1',
      tel: '12345678',
      email: 'yss565797726@hh.com',
      create_time: '2020-01-04 09:41:00',
    },
    {
      id: 2,
      name: '靓女2',
      tel: '12345678',
      email: 'yss565797726@hh.com',
      create_time: '2020-01-04 09:41:00',
    },
    {
      id: 3,
      name: '靓女3',
      tel: '12345678',
      email: 'yss565797726@hh.com',
      create_time: '2020-01-04 09:41:00',
    },
  ]
}

export function getAppletList() {
  return [
    {
      id: 0,
      name: '党史学习教育',
      avatar: '/src/assets/img/applet/logo.png',
      describe: '记录中国共产党重大的事件',
      active: true,
    },
    {
      id: 1,
      name: 'JUMP',
      avatar: '/src/assets/img/applet/logo.png',
      describe: 'encodeURIComponent',
      active: false,
    },
    {
      id: 2,
      name: '党史学习教育',
      avatar: '/src/assets/img/applet/logo.png',
      describe: '记录中国共产党重大的事件',
      active: true,
    },
    {
      id: 3,
      name: 'JUMP',
      avatar: '/src/assets/img/applet/logo.png',
      describe: 'encodeURIComponent',
      active: false,
    },
  ]
}

export default [
  // mock user login
  {
    url: '/fyb-test/login',
    timeout: 200,
    method: 'post',
    response: ({ body }) => {
      console.log('111111')
      const { username, password } = body
      const checkUser = createFakeUserList().find(
        (item) => item.username === username && password === item.password
      )
      if (!checkUser) {
        return resultError('Incorrect account or password！')
      }
      const { userId, username: _username, token, realName, desc, roles } = checkUser
      return resultSuccess({
        roles,
        userId,
        username: _username,
        token,
        realName,
        desc,
      })
    },
  },
  {
    url: '/fyb-test/getUserInfo',
    method: 'get',
    response: (request: requestParams) => {
      const token = getRequestToken(request)
      if (!token) return resultError('Invalid token')
      const checkUser = createFakeUserList().find((item) => item.token === token)
      if (!checkUser) {
        return resultError('The corresponding user information was not obtained!')
      }
      return resultSuccess(checkUser)
    },
  },
  {
    url: '/mock/zy/aaa',
    method: 'get',
    response: () => {
      const checkUser = createFakeUserList()
      if (!checkUser) {
        return resultError('The corresponding user information was not obtained!')
      }
      return resultSuccess(checkUser)
    },
  },
  //设备列表
  {
    url: '/mock/yss/devicetList',
    method: 'get',
    response: () => {
      const checkUser = devicetList()
      if (!checkUser) {
        return resultError('The corresponding user information was not obtained!')
      }
      return resultSuccess(checkUser)
    },
  },
  //企业信息
  {
    url: '/mock/yss/companyInfo',
    method: 'get',
    response: () => {
      const checkUser = companyInfo()
      if (!checkUser) {
        return resultError('The corresponding user information was not obtained!')
      }
      return resultSuccess(checkUser)
    },
  },
  //成员信息
  {
    url: '/mock/yss/memberList',
    method: 'get',
    response: () => {
      const checkUser = memberList()
      if (!checkUser) {
        return resultError('The corresponding user information was not obtained!')
      }
      return resultSuccess(checkUser)
    },
  },

  //已创建的订阅号列表
  {
    url: '/mock/yq/getAppletList',
    method: 'get',
    response: () => {
      const getResults = getAppletList()
      if (!getResults) {
        return resultError('The corresponding user information was not obtained!')
      }
      return resultSuccess(getResults)
    },
  },
] as MockMethod[]
